<template>
  <v-menu
    class="dropdown-menu"
    tile
    v-model="subMenu"
    :open-on-hover="true"
    :close-on-click="true"
    :close-on-content-click="true"
    :offsetY="true"
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-bind="props" v-on="on">
        {{ item.name }}
        <v-icon small right>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-list tile>
      <v-list-item
        v-for="(child, index) in item.children"
        :key="index"
        dense
        :to="child.type == 'page' ? child.link : null"
        :href="child.type == 'url' ? child.link : null"
        :target="child.type == 'url' ? '_blank' : ''"
        @click="clicked(child)"
      >
        <v-list-item-title>{{ child.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import PageMenuButton from './PageMenuButton'
import SectionMenuButton from './SectionMenuButton'
import UrlMenuButton from './UrlMenuButton'
import FileMenuButton from './FileMenuButton'

export default {
  name: 'ParentMenuButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  },
  components: {
    PageMenuButton,
    SectionMenuButton,
    UrlMenuButton,
    FileMenuButton
  },
  data: () => ({
    subMenu: false
  }),
  methods: {
    clicked(item) {
      if (item.type == 'section') {
        this.$vuetify.goTo(item.link, {
          offset: this.$store.state.section.stickyHeader.height
        })
      }
    }
  }
}
</script>

<style>
.v-menu__content,
.v-list {
  border-radius: 0 !important;
  z-index: 400 !important;
}
</style>
